import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for `/libraries/task-catalog/*`.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 *
 * Note: `catalogTaskRoute` (`:idOrAdd`) and `catalogTaskFolderRoute` (`:folderId`) share the same
 * URL shape. The route tree mounts `TaskCatalogSegmentPage` on `catalogTaskRoute`; folder URLs keep
 * using `catalogTaskFolderRoute.url(...)` for builders.
 */
export const catalogTasksRoute = defineRoute("/libraries/task-catalog");
export const constraintItemsCatalogRoute = defineRoute("/libraries/task-catalog/constraint-and-allowance-catalog");
export const catalogTaskLaborCostsRoute = defineRoute("/libraries/task-catalog/:globalPlanTaskId/labor-costs");
export const catalogTaskRoute = defineRoute("/libraries/task-catalog/:idOrAdd");
export const catalogTaskFolderRoute = defineRoute("/libraries/task-catalog/:folderId");
